import React from 'react'
import Icon from 'react-icon-base'

const Edit = props => (
  <Icon viewBox="-1 -1 20 20" {...props}>
    <g><path d="M15.6207 12.8602C15.9237 13.0624 15.9237 13.5679 15.5533 13.8712L13.9035 15.5225C13.6005 15.8258 13.1964 15.8258 12.8934 15.5225L6.36129 8.98461C4.71144 9.62492 2.79222 9.28792 1.41173 7.90619C-0.0361055 6.45707 -0.406481 4.30023 0.468952 2.5815L3.63398 5.68196L5.78889 3.52512L2.69121 0.424667C4.4084 -0.350446 6.56331 -0.0808416 8.01115 1.36828C9.39164 2.75001 9.72834 4.67094 9.0886 6.32227L15.6207 12.8602Z" transform="translate(0.239258 0.375)" /></g>
  </Icon>
)

export default Edit